/**
 * Ссылки в тексте — кликабельные (09.10.2026): в чат, «Что снять» и бриф
 * кидают ссылки на ролики TikTok и YouTube, а копировать их было неудобно.
 * Длинная ссылка переносится — у родителя нужен [overflow-wrap:anywhere].
 */
const URL_RE = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;

export function Linkified({ text }: { text: string }) {
  const parts = text.split(URL_RE);
  return (
    <>
      {parts.map((part, i) => {
        if (i % 2 === 0) return part;
        // Точка или скобка в конце — конец предложения, а не часть ссылки.
        const tail = part.match(/[.,;:!?)\]]+$/)?.[0] ?? "";
        const url = tail ? part.slice(0, -tail.length) : part;
        const href = url.startsWith("http") ? url : `https://${url}`;
        return (
          <span key={i}>
            <a href={href} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:opacity-80">
              {url}
            </a>
            {tail}
          </span>
        );
      })}
    </>
  );
}
